import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function ViewBusiness() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [business, setBusiness] = useState({});
  const [admin, setAdmin] = useState({});
  const [wallets, setWallets] = useState([]);

  const [statistics, setStatistics] = useState({});
  const [sales, setSales] = useState({});
  const [purchases, setPurchases] = useState({});
  const [expenses, setExpenses] = useState({});
  const [profit, setProfit] = useState({});

  const [recentInvoices, setRecentInvoices] = useState([]);
  const [recentPurchases, setRecentPurchases] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [lowStock, setLowStock] = useState([]);

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {

    try {

      const res =
        await API.get(
          `/businesses/${id}/dashboard`
        );

      setBusiness(
        res.data.business
      );

      setAdmin(
        res.data.admin || {}
      );

      setWallets(
        res.data.wallets || []
      );

      setStatistics(
        res.data.statistics || {}
      );

      setSales(
        res.data.sales || {}
      );

      setPurchases(
        res.data.purchases || {}
      );

      setExpenses(
        res.data.expenses || {}
      );

      setProfit(
        res.data.profit || {}
      );

      setRecentInvoices(
        res.data.recentInvoices || []
      );

      setRecentPurchases(
        res.data.recentPurchases || []
      );

      setTopProducts(
        res.data.topProducts || []
      );

      setLowStock(
        res.data.lowStock || []
      );

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }

  };

  const getWalletBalance = (type) => {

    const wallet =
      wallets.find(
        item =>
          item.wallet_type === type
      );

    return wallet
      ? Number(wallet.balance).toFixed(2)
      : "0.00";

  };

  if (loading) {

    return (
      <div
        className="
        flex
        justify-center
        items-center
        h-[400px]
        text-xl
        "
      >
        Loading...
      </div>
    );

  }

  return (

    <div>

      <div
        className="
        flex
        justify-between
        items-center
        flex-wrap
        gap-4
        mb-8
        "
      >

        <div>

          <h1
            className="
            text-4xl
            font-bold
            "
          >
            Business Dashboard
          </h1>

          <p
            className="
            text-gray-400
            mt-2
            "
          >
            Complete overview of business
          </p>

        </div>

        <button
          onClick={() =>
            navigate("/admin/businesses")
          }
          className="
          px-6
          py-3
          rounded-xl
          bg-yellow-500
          text-black
          font-semibold
          "
        >
          Back
        </button>

      </div>

      {/* ==============================
          BUSINESS PROFILE
      ============================== */}

      <div
        className="
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        p-8
        "
      >

        <div
          className="
          flex
          flex-col
          lg:flex-row
          gap-10
          "
        >

          <img
            src={
              business.logo
                ? `${process.env.REACT_APP_API_URL}/uploads/${business.logo}`
                : "https://ui-avatars.com/api/?name=Business"
            }
            alt=""
            className="
            w-40
            h-40
            rounded-3xl
            object-cover
            border-4
            border-yellow-500
            "
          />

          <div className="flex-1">

            <h2
              className="
              text-4xl
              font-bold
              "
            >
              {business.business_name}
            </h2>

            <p
              className="
              text-gray-400
              mt-2
              "
            >
              Owner : {business.owner_name}
            </p>

            <div
              className="
              grid
              md:grid-cols-2
              xl:grid-cols-3
              gap-6
              mt-8
              "
            >

              <div>

                <p className="text-gray-500">
                  Phone
                </p>

                <h4 className="font-semibold">
                  {business.phone || "-"}
                </h4>

              </div>

              <div>

                <p className="text-gray-500">
                  Email
                </p>

                <h4 className="font-semibold">
                  {business.email || "-"}
                </h4>

              </div>

              <div>

                <p className="text-gray-500">
                  GST
                </p>

                <h4 className="font-semibold">
                  {business.gst_no || "-"}
                </h4>

              </div>

              <div>

                <p className="text-gray-500">
                  PAN
                </p>

                <h4 className="font-semibold">
                  {business.pan_no || "-"}
                </h4>

              </div>

              <div>

                <p className="text-gray-500">
                  Created
                </p>

                <h4 className="font-semibold">
                  {new Date(
                    business.created_at
                  ).toLocaleDateString()}
                </h4>

              </div>

              <div>

                <p className="text-gray-500">
                  Status
                </p>

                <span
                  className={`
                  px-3
                  py-1
                  rounded-full
                  text-sm

                  ${Number(business.status) === 1
                      ? "bg-green-600"
                      : "bg-red-600"
                    }
                  `}
                >
                  {
                    Number(business.status) === 1
                      ? "Active"
                      : "Inactive"
                  }
                </span>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ==============================
          BUSINESS ADMIN
      ============================== */}

      <div
        className="
        mt-8
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        p-8
        "
      >

        <h2
          className="
          text-2xl
          font-bold
          mb-6
          "
        >
          Business Administrator
        </h2>

        <div
          className="
          grid
          md:grid-cols-2
          xl:grid-cols-4
          gap-6
          "
        >

          <div>

            <p className="text-gray-500">
              Name
            </p>

            <h4 className="font-semibold">
              {admin.name || "-"}
            </h4>

          </div>

          <div>

            <p className="text-gray-500">
              Phone
            </p>

            <h4 className="font-semibold">
              {admin.phone || "-"}
            </h4>

          </div>

          <div>

            <p className="text-gray-500">
              Email
            </p>

            <h4 className="font-semibold">
              {admin.email || "-"}
            </h4>

          </div>

        </div>

      </div>

      {/* ==============================
          WALLET SUMMARY
      ============================== */}

      <div
        className="
        mt-8
        grid
        md:grid-cols-3
        gap-6
        "
      >

        <div
          className="
          bg-[#111]
          rounded-3xl
          p-6
          border
          border-green-500/20
          "
        >
          <p className="text-gray-400">
            Cash Wallet
          </p>

          <h2
            className="
            text-4xl
            font-bold
            text-green-400
            mt-4
            "
          >
            ₹{getWalletBalance("cash")}
          </h2>

        </div>

        <div
          className="
          bg-[#111]
          rounded-3xl
          p-6
          border
          border-blue-500/20
          "
        >
          <p className="text-gray-400">
            Bank Wallet
          </p>

          <h2
            className="
            text-4xl
            font-bold
            text-blue-400
            mt-4
            "
          >
            ₹{getWalletBalance("bank")}
          </h2>

        </div>

        <div
          className="
          bg-[#111]
          rounded-3xl
          p-6
          border
          border-yellow-500/20
          "
        >
          <p className="text-gray-400">
            EDT Wallet
          </p>

          <h2
            className="
            text-4xl
            font-bold
            text-yellow-400
            mt-4
            "
          >
            ₹{getWalletBalance("edt")}
          </h2>

        </div>

      </div>

      {/* ==============================
          STATISTICS
      ============================== */}

      <div
        className="
        mt-10
        "
      >

        <h2
          className="
          text-2xl
          font-bold
          mb-6
          "
        >
          Statistics
        </h2>

        <div
          className="
          grid
          sm:grid-cols-2
          lg:grid-cols-5
          gap-6
          "
        >

          <StatCard
            title="Products"
            value={statistics.products}
          />

          <StatCard
            title="Categories"
            value={statistics.categories}
          />

          <StatCard
            title="Customers"
            value={statistics.customers}
          />

          <StatCard
            title="Suppliers"
            value={statistics.suppliers}
          />

          <StatCard
            title="Users"
            value={statistics.users}
          />

          <StatCard
            title="Invoices"
            value={statistics.invoices}
          />

          <StatCard
            title="Purchases"
            value={statistics.purchases}
          />

          <StatCard
            title="Expenses"
            value={statistics.expenses}
          />

          <StatCard
            title="Sales Returns"
            value={statistics.sales_returns}
          />

          <StatCard
            title="Purchase Returns"
            value={statistics.purchase_returns}
          />

        </div>

      </div>

      {/* ==============================
          SALES SUMMARY
      ============================== */}

      <div
        className="
        mt-10
        grid
        lg:grid-cols-3
        gap-6
        "
      >

        <SummaryCard
          title="Today's Sales"
          amount={sales.today}
          color="text-green-400"
        />

        <SummaryCard
          title="This Month Sales"
          amount={sales.month}
          color="text-blue-400"
        />

        <SummaryCard
          title="Total Sales"
          amount={sales.total}
          color="text-yellow-400"
        />

      </div>

      {/* ==============================
          PURCHASE SUMMARY
      ============================== */}

      <div
        className="
        mt-8
        grid
        lg:grid-cols-3
        gap-6
        "
      >

        <SummaryCard
          title="Today's Purchase"
          amount={purchases.today}
          color="text-red-400"
        />

        <SummaryCard
          title="This Month Purchase"
          amount={purchases.month}
          color="text-purple-400"
        />

        <SummaryCard
          title="Total Purchase"
          amount={purchases.total}
          color="text-orange-400"
        />

      </div>

      {/* ==============================
          EXPENSE SUMMARY
      ============================== */}

      <div
        className="
        mt-8
        grid
        lg:grid-cols-3
        gap-6
        "
      >

        <SummaryCard
          title="Today's Expense"
          amount={expenses.today}
          color="text-red-400"
        />

        <SummaryCard
          title="This Month Expense"
          amount={expenses.month}
          color="text-pink-400"
        />

        <SummaryCard
          title="Total Expense"
          amount={expenses.total}
          color="text-orange-400"
        />

      </div>

      {/* ==============================
          PROFIT & LOSS
      ============================== */}

      <div
        className="
        mt-10
        "
      >

        <h2
          className="
          text-2xl
          font-bold
          mb-6
          "
        >
          Profit & Loss
        </h2>

        <div
          className="
          grid
          lg:grid-cols-3
          gap-6
          "
        >

          <SummaryCard
            title="Income"
            amount={profit.income}
            color="text-green-400"
          />

          <SummaryCard
            title="Expense"
            amount={profit.expense}
            color="text-red-400"
          />

          <SummaryCard
            title="Net Profit"
            amount={profit.profit}
            color={
              Number(profit.profit) >= 0
                ? "text-green-400"
                : "text-red-400"
            }
          />

        </div>

      </div>

      {/* ==============================
          RECENT INVOICES
      ============================== */}

      <div
        className="
        mt-10
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        overflow-hidden
        "
      >

        <div className="p-6 border-b border-yellow-500/20">

          <h2 className="text-2xl font-bold">
            Recent Invoices
          </h2>

        </div>

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-black/40">

              <tr>

                <th className="text-left p-4">
                  Invoice No
                </th>

                <th className="text-left p-4">
                  Date
                </th>

                <th className="text-right p-4">
                  Amount
                </th>

              </tr>

            </thead>

            <tbody>

              {
                recentInvoices.length ?

                  recentInvoices.map(
                    (item, index) => (
                      <tr
                        key={index}
                        className="border-t border-yellow-500/10"
                      >

                        <td className="p-4">
                          {item.invoice_no}
                        </td>

                        <td className="p-4">
                          {
                            new Date(
                              item.invoice_date
                            ).toLocaleDateString()
                          }
                        </td>

                        <td className="p-4 text-right text-green-400 font-semibold">
                          ₹{Number(item.grand_total).toLocaleString()}
                        </td>

                      </tr>
                    )
                  )

                  :

                  <tr>

                    <td
                      colSpan={3}
                      className="text-center p-8 text-gray-500"
                    >
                      No Invoices
                    </td>

                  </tr>

              }

            </tbody>

          </table>

        </div>

      </div>

      {/* ==============================
          RECENT PURCHASES
      ============================== */}

      <div
        className="
        mt-10
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        overflow-hidden
        "
      >

        <div className="p-6 border-b border-yellow-500/20">

          <h2 className="text-2xl font-bold">
            Recent Purchases
          </h2>

        </div>

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-black/40">

              <tr>

                <th className="text-left p-4">
                  Invoice No
                </th>

                <th className="text-left p-4">
                  Date
                </th>

                <th className="text-right p-4">
                  Amount
                </th>

              </tr>

            </thead>

            <tbody>

              {
                recentPurchases.length ?

                  recentPurchases.map(
                    (item, index) => (
                      <tr
                        key={index}
                        className="border-t border-yellow-500/10"
                      >

                        <td className="p-4">
                          {item.invoice_no}
                        </td>

                        <td className="p-4">
                          {
                            new Date(
                              item.purchase_date
                            ).toLocaleDateString()
                          }
                        </td>

                        <td className="p-4 text-right text-blue-400 font-semibold">
                          ₹{Number(item.grand_total).toLocaleString()}
                        </td>

                      </tr>
                    )
                  )

                  :

                  <tr>

                    <td
                      colSpan={3}
                      className="text-center p-8 text-gray-500"
                    >
                      No Purchases
                    </td>

                  </tr>

              }

            </tbody>

          </table>

        </div>

      </div>

      {/* ==============================
          TOP SELLING PRODUCTS
      ============================== */}

      <div
        className="
        mt-10
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        overflow-hidden
        "
      >

        <div className="p-6 border-b border-yellow-500/20">

          <h2 className="text-2xl font-bold">
            Top Selling Products
          </h2>

        </div>

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-black/40">

              <tr>

                <th className="text-left p-4">
                  Product
                </th>

                <th className="text-center p-4">
                  Qty Sold
                </th>

                <th className="text-right p-4">
                  Revenue
                </th>

              </tr>

            </thead>

            <tbody>

              {
                topProducts.length ?

                  topProducts.map(
                    (item, index) => (
                      <tr
                        key={index}
                        className="border-t border-yellow-500/10"
                      >

                        <td className="p-4">
                          {item.name}
                        </td>

                        <td className="p-4 text-center">
                          {item.qty}
                        </td>

                        <td className="p-4 text-right text-yellow-400 font-semibold">
                          ₹{Number(item.revenue).toLocaleString()}
                        </td>

                      </tr>
                    )
                  )

                  :

                  <tr>

                    <td
                      colSpan={3}
                      className="text-center p-8 text-gray-500"
                    >
                      No Data
                    </td>

                  </tr>

              }

            </tbody>

          </table>

        </div>

      </div>

      {/* ==============================
          LOW STOCK PRODUCTS
      ============================== */}

      <div
        className="
        mt-10
        bg-[#111]
        rounded-3xl
        border
        border-yellow-500/20
        overflow-hidden
        "
      >

        <div className="p-6 border-b border-yellow-500/20">

          <h2 className="text-2xl font-bold">
            Low Stock Products
          </h2>

        </div>

        <div className="overflow-x-auto">

          <table className="w-full">

            <thead className="bg-black/40">

              <tr>

                <th className="text-left p-4">
                  Product
                </th>

                <th className="text-center p-4">
                  Stock
                </th>

              </tr>

            </thead>

            <tbody>

              {
                lowStock.length ?

                  lowStock.map(
                    (item, index) => (
                      <tr
                        key={index}
                        className="border-t border-yellow-500/10"
                      >

                        <td className="p-4">
                          {item.name}
                        </td>

                        <td className="p-4 text-center">

                          <span
                            className="
                            bg-red-500
                            px-3
                            py-1
                            rounded-full
                            text-sm
                            "
                          >
                            {item.stock}
                          </span>

                        </td>

                      </tr>
                    )
                  )

                  :

                  <tr>

                    <td
                      colSpan={2}
                      className="
                    p-8
                    text-center
                    text-gray-500
                    "
                    >
                      No Low Stock Products
                    </td>

                  </tr>

              }

            </tbody>

          </table>

        </div>

      </div>

      {/* ==============================
          BUSINESS HEALTH
      ============================== */}

      <div
        className="
        mt-10
        grid
        md:grid-cols-3
        gap-6
        "
      >

        <div
          className="
          bg-[#111]
          rounded-3xl
          p-8
          border
          border-green-500/20
          "
        >

          <h3 className="text-xl font-bold">
            Total Revenue
          </h3>

          <h2
            className="
            text-4xl
            font-bold
            text-green-400
            mt-4
            "
          >
            ₹
            {Number(
              sales.total || 0
            ).toLocaleString()}
          </h2>

        </div>

        <div
          className="
          bg-[#111]
          rounded-3xl
          p-8
          border
          border-red-500/20
          "
        >

          <h3 className="text-xl font-bold">
            Total Expense
          </h3>

          <h2
            className="
            text-4xl
            font-bold
            text-red-400
            mt-4
            "
          >
            ₹
            {Number(
              profit.expense || 0
            ).toLocaleString()}
          </h2>

        </div>

        <div
          className={`
    bg-[#111]
    rounded-3xl
    p-8
    border
    ${Number(profit.profit) >= 0
              ? "border-green-500/20"
              : "border-red-500/20"
            }
  `}
        >

          <h3 className="text-xl font-bold">
            Net Profit
          </h3>

          <h2
            className={`
            text-4xl
            font-bold
            mt-4

            ${Number(profit.profit) >= 0
                ? "text-green-400"
                : "text-red-400"
              }
            `}
          >
            ₹
            {Number(
              profit.profit || 0
            ).toLocaleString()}
          </h2>

        </div>

      </div>

      {/* ==============================
          FOOTER
      ============================== */}

      <div
        className="
        mt-12
        text-center
        text-gray-500
        pb-10
        "
      >
        Business Dashboard Overview
      </div>

    </div>

  );

}

function StatCard({ title, value }) {

  return (
    <div className="bg-[#111] rounded-2xl p-6 border border-yellow-500/20">
      <p className="text-gray-400">{title}</p>

      <h2 className="text-4xl font-bold mt-3">
        {value || 0}
      </h2>
    </div>
  );
}

function SummaryCard({
  title,
  amount,
  color
}) {

  return (
    <div className="bg-[#111] rounded-2xl p-6 border border-yellow-500/20">

      <p className="text-gray-400">
        {title}
      </p>

      <h2 className={`text-4xl font-bold mt-3 ${color}`}>
        ₹{Number(amount || 0).toLocaleString()}
      </h2>

    </div>
  );
}

export default ViewBusiness;